import { render, staticRenderFns } from "./ScrapEdit.vue?vue&type=template&id=8565b0ea&"
import script from "./ScrapEdit.vue?vue&type=script&lang=js&"
export * from "./ScrapEdit.vue?vue&type=script&lang=js&"
import style0 from "./ScrapEdit.vue?vue&type=style&index=0&id=8565b0ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports